import { createStandardAction, createAsyncAction } from 'typesafe-actions'
import { GetDashboardReq, GetActivityApiResponse } from './types'

export const getDashbaordAction = createAsyncAction(
  'cmpj/sitevisit/construct/dashboard/FETCH_CONSTRUCT_DASHBOARD_REQUEST',
  'cmpj/sitevisit/construct/dashboard/FETCH_CONSTRUCT_DASHBOARD_SUCCESS',
  'cmpj/sitevisit/construct/dashboard/FETCH_CONSTRUCT_DASHBOARD_FAILURE'
)<GetDashboardReq, GetActivityApiResponse, any>()

export const sortingDashboard = createStandardAction(
  'cmpj/sitevisit/construct/dashboard/SORTING'
)<string>()
